
import {
    defineComponent,
    inject,
    provide,
    ref
} from 'vue'

//components
import itemFile from "./itemFile.vue"

export default defineComponent({
    components: {itemFile},
    setup() {
        const open_dialog_view_file = ref(false)
        const listHistory = inject('listHistory')

        return {
            open_dialog_view_file,
            listHistory,
        }
    }
})
